import { useEffect } from 'react';
import { useReactFlow, useStoreApi } from '@xyflow/react';
import {useEdgeBuilder} from "../association-network-context.jsx";

const KeysHandler = () => {
    const { deleteElements } = useReactFlow();
    const {setNewEdge, setPanelOpened, setSelectedNode} = useEdgeBuilder();
    const store = useStoreApi();

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setPanelOpened(null)
                setSelectedNode(null)
                setNewEdge(null)
            }
        }

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Delete') {
                const { nodes, edges } = store.getState();
                const selectedNodes = nodes.filter((n) => n.selected);
                const selectedEdges = edges.filter((e) => e.selected);

                if (selectedNodes.length > 0 || selectedEdges.length > 0) {
                    deleteElements({
                        nodes: selectedNodes,
                        edges: selectedEdges,
                    });
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [deleteElements, store]);

    return null;
}

export default KeysHandler;
